import React from 'react'
import moment from "moment";

const LoadedTemplate = ({selectedTemplate}) => {
    return (
        <div className="d-flex flex-row align-items-center mt-3">
            <div className="d-flex flex-row mr-4" style={{width: '30%'}}>
                <p className="m-0 mr-1 mt-1">Template: </p>
                <input
                    type="text"
                    disabled
                    value={selectedTemplate?.name}
                />
            </div>
            <div className="d-flex flex-row" style={{width: '20%'}}>
                <p className="m-0 mr-1 mt-1" style={{width: '100%'}}>Last Date Sent: </p>
                <input
                    disabled
                    type="text"
                    value={selectedTemplate && selectedTemplate.date_sent ? moment(selectedTemplate.date_sent, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                />
            </div>
        </div>
    )
}
export default LoadedTemplate;